import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["circleColor", "letterColor", "letter"];
var _templateObject, _templateObject2;
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
var Circle = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: ", ";\n"])), function (_ref) {
  var circleColor = _ref.circleColor;
  return circleColor;
});
var LetterComponent = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 18px;\n  font-weight: 500;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_ref2) {
  var letterColor = _ref2.letterColor;
  return letterColor;
});
var Letter = function Letter(_ref3) {
  var circleColor = _ref3.circleColor,
    letterColor = _ref3.letterColor,
    letter = _ref3.letter,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Circle, _extends({}, props, {
    circleColor: circleColor
  }), /*#__PURE__*/React.createElement(LetterComponent, {
    letterColor: letterColor
  }, letter));
};
Letter.defaultProps = {
  letterColor: '#9966ff',
  circleColor: '#ffffff'
};
process.env.NODE_ENV !== "production" ? Letter.propTypes = {
  letter: PropTypes.string.isRequired,
  letterColor: PropTypes.string,
  circleColor: PropTypes.string
} : void 0;
export default Letter;